export default __webpack_public_path__ + "static/media/14.b7948327.svg";